import { Navigate } from 'react-router-dom';
import { Spinner } from '@/components/ui/Spinner';
import { useReportAccess } from '../hooks';

/**
 * config-aware 라우트 가드 — worklog_report.min_role 에 따라 접근 허용 여부가 런타임에 바뀐다.
 * 보안 경계는 서버(requireMinRole + 2차 방어). 이 가드는 UX 보조.
 */
export function ReportRouteGuard({ children }: { children: React.ReactNode }) {
  const { data, isLoading, isError } = useReportAccess();

  if (isLoading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center gap-2 text-gray-400">
        <Spinner size="md" />
        <span className="text-sm">접근 권한 확인 중...</span>
      </div>
    );
  }

  if (isError || !data?.can_access) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
